import {
  FormModel,
  Avatar,
  Affix,
  Breadcrumb,
  Button,
  Badge,
  Cascader,
  Col,
  Checkbox,
  Collapse,
  DatePicker,
  Divider,
  Card,
  Drawer,
  Dropdown,
  Descriptions,
  Form,
  Icon,
  Input,
  InputNumber,
  Switch,
  Layout,
  List,
  ConfigProvider,
  Menu,
  message,
  notification,
  Row,
  Radio,
  Table,
  Tag,
  Timeline,
  TimePicker,
  Tooltip,
  Tree,
  Calendar,
  TreeSelect,
  Transfer,
  Popconfirm,
  Spin,
  Progress,
  Select,
  Modal,
  Upload,
  Steps,
  PageHeader,
  AutoComplete,
  Popover,
  Tabs,
} from "ant-design-vue";
import axios from "axios";
import Vue from "vue";
import 'ant-design-vue/dist/antd.css';
import VueAxios from "vue-axios";
import Router from "vue-router";
import App from "./App";
import router from "./router-config";
import store from "./store";
import common from "./assets/css/common.css";
import "./assets/css/shadcn-theme.css";
import "./assets/css/modern-components.css";
import "./assets/css/modern-design.css";
import "./assets/css/shadcn-ui.css";
import "./assets/css/tailwind.compiled.css";
import "./assets/css/familyPageLayout.css";
import Abuot from "./common/abuot";
import Password from "./components/login/password";
import PasswordLogin from "./components/login/password_login";
import UserInfo from "./common/userInfo";
import VueCountUp from "vue-countupjs";
import vcolorpicker from "vcolorpicker";
//引入nprogress
import NProgress from "nprogress"; // 进度条
import cf from "./components/columns-filter";
import "nprogress/nprogress.css"; //这个样式必须引入

// 引入ecahrts
import * as echarts from "echarts/core";
import "./common/js/dialogdrag";
import "./common/css/common.css";

// 图标集
import 'boxicons';
// 路由拦截
import './permission.js'
import './common/vant.js'


Vue.use(FormModel);
Vue.component(Collapse);
Vue.component("cf", cf);
Vue.component(PageHeader.name, PageHeader);
Vue.component(AutoComplete.name, AutoComplete);
Vue.component(Steps.name, Steps);
Vue.component(Steps.Step.name, Steps.Step);
Vue.component(Button.name, Button);
Vue.component(Calendar.name, Calendar);
Vue.component(Popover.name, Popover);
Vue.component(Badge.name, Badge);
Vue.component(Form.name, Form);
Vue.component(Form.Item.name, Form.Item);
Vue.component(Input.name, Input);
Vue.component(Input.Search.name, Input.Search);
Vue.component(Cascader.name, Cascader);
Vue.component(Card.name, Card);
Vue.component(Input.TextArea.name, Input.TextArea);
Vue.component(InputNumber.name, InputNumber);
Vue.component(Switch.name, Switch);
Vue.component(DatePicker.name, DatePicker);
Vue.component(DatePicker.MonthPicker.name, DatePicker.MonthPicker);
Vue.component(DatePicker.RangePicker.name, DatePicker.RangePicker);
Vue.component(Descriptions.name, Descriptions);
Vue.component(Descriptions.Item.name, Descriptions.Item);
Vue.component(Icon.name, Icon);
Vue.component(Menu.name, Menu);
Vue.component(Menu.Item.name, Menu.Item);
Vue.component(Menu.SubMenu.name, Menu.SubMenu);
Vue.component(Menu.Divider.name, Menu.Divider);
Vue.component(List.name, List);
Vue.component(List.Item.name, List.Item);
Vue.component(Layout.name, Layout);
Vue.component(Layout.Sider.name, Layout.Sider);
Vue.component(Layout.Header.name, Layout.Header);
Vue.component(Layout.Content.name, Layout.Content);
Vue.component(Layout.Footer.name, Layout.Footer);
Vue.component(ConfigProvider.name, ConfigProvider);
Vue.component(Row.name, Row);
Vue.component(Radio.name, Radio);
Vue.component(Radio.Group.name, Radio.Group);
Vue.component(Col.name, Col);
Vue.component(Checkbox.name, Checkbox);
Vue.component(Checkbox.Group.name, Checkbox.Group);
Vue.component(Collapse.name, Collapse);
Vue.component(Dropdown.name, Dropdown);
Vue.component(Avatar.name, Avatar);
Vue.component(Drawer.name, Drawer);
Vue.component(Breadcrumb.name, Breadcrumb);
Vue.component(Breadcrumb.Item.name, Breadcrumb.Item);
Vue.component(Table.name, Table);
Vue.component(Tag.name, Tag);
Vue.component(Timeline.name, Timeline);
Vue.component(Timeline.Item.name, Timeline.Item);
Vue.component(TimePicker.name, TimePicker);
Vue.component(Divider.name, Divider);
Vue.component(Tooltip.name, Tooltip);
Vue.component(Tree.name, Tree);
Vue.component(TreeSelect.name, TreeSelect);
Vue.component(Transfer.name, Transfer);
Vue.component(Popconfirm.name, Popconfirm);
Vue.component(Spin.name, Spin);
Vue.component(Affix.name, Affix);
Vue.component(Progress.name, Progress);
Vue.component(Select.name, Select);
Vue.component(Select.Option.name, Select.Option);
Vue.component(Modal.name, Modal);
Vue.component(Upload.name, Upload);
Vue.component("abuot", Abuot);
Vue.component("password", Password);
Vue.component("password-login", PasswordLogin);
Vue.component("userInfo", UserInfo);
Vue.component(vcolorpicker);
Vue.component(Card.Meta.name, Card.Meta);
Vue.component(Tabs.name, Tabs);

Vue.use(Collapse);
Vue.use(Tabs);
Vue.use(VueAxios, axios);
Vue.use(Router);
Vue.use(common);
Vue.use(VueCountUp);

// 简单配置
NProgress.inc(0.2);
NProgress.configure({ easing: "ease", speed: 500, showSpinner: false });

Vue.prototype.$message = message;
Vue.prototype.$notification = notification;
Vue.prototype.$confirm = Modal.confirm;
Vue.prototype.$error = Modal.error;
Vue.prototype.$warning = Modal.warning;

// echarts
Vue.prototype.$echarts = echarts;

Vue.prototype.$uuid = () => {
  function S4() {
    return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
  }

  return (
    S4() +
    S4() +
    "-" +
    S4() +
    "-" +
    S4() +
    "-" +
    S4() +
    "-" +
    S4() +
    S4() +
    S4()
  );
};

Vue.prototype.$fileBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
};

//写cookies

Vue.prototype.$setCookie = function (c_name, value, expiredays) {
  var exdate = new Date();
  exdate.setDate(exdate.getDate() + expiredays);
  document.cookie =
    c_name +
    "=" +
    escape(value) +
    (expiredays == null ? "" : ";expires=" + exdate.toGMTString());
};

//读取cookies
function getCookie(name) {
  var arr,
    reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");

  if ((arr = document.cookie.match(reg))) return arr[2];
  else return null;
}

//删除cookies
Vue.prototype.$delCookie = function (name) {
  var exp = new Date();
  exp.setTime(exp.getTime() - 1);
  var cval = getCookie(name);
  if (cval != null)
    document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString();
};

Array.prototype.remove = function (val) {
  var index = this.indexOf(val);
  if (index > -1) {
    this.splice(index, 1);
  }
};

Array.prototype.contains = function (element) {
  //利用Array的原型prototype点出一个我想要封装的方法名contains
  for (var i = 0; i < this.length; i++) {
    if (this[i] == element) {
      //如果数组中某个元素和你想要测试的元素对象element相等，则证明数组中包含这个元素，返回true
      return true;
    }
  }
};

Vue.prototype.getUrlParam = function (name) {
  console.log(location.href);
  const after = window.location.hash.split("?", 2)[1];
  if (after) {
    const reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
    const r = after.match(reg);
    if (r != null) {
      return decodeURIComponent(r[2]);
    } else {
      return false;
    }
  }
};
message.config({
  top: "200px",
  duration: 3,
  maxCount: 1,
});

notification.config({
  placement: "topRight",
  top: "50px",
  duration: 3,
});

Vue.config.productionTip = false;

function isFamilyApiUrl(url) {
  if (!url) return false;
  return url.indexOf("/web/family/") !== -1 && url.indexOf("/web/family/auth/") === -1;
}

function clearFamilySession() {
  sessionStorage.removeItem("familyIsLogin");
  sessionStorage.removeItem("familyToken");
  sessionStorage.removeItem("familyUser");
}

let authNotifyAt = 0;
let authRedirecting = false;
function redirectOnAuthFail(isFamily, msg) {
  const target = isFamily ? "/family/login" : "/login";
  const currentPath = (router.currentRoute && router.currentRoute.path) || "";
  // 家属端首页允许匿名访问：首次进入或后台请求401时不弹窗、不跳转
  if (isFamily && currentPath === "/family") {
    clearFamilySession();
    return;
  }
  if (isFamily) {
    clearFamilySession();
  } else if (store.state.isLogin) {
    store.commit("setLoginOut");
  }
  const now = Date.now();
  if (now - authNotifyAt > 3000) {
    Vue.prototype.$message.warning(msg || "登录已过期，请重新登录");
    authNotifyAt = now;
  }
  if (!authRedirecting && currentPath !== target) {
    authRedirecting = true;
    router.replace(target);
    setTimeout(() => {
      authRedirecting = false;
    }, 800);
  }
}

//配置发送请求前的拦截器 可以设置token信息
axios.interceptors.request.use(
  (config) => {
    if (config.url && !/^https?:\/\//i.test(config.url) && config.url.charAt(0) !== "/") {
      config.url = `/${config.url}`;
    }
    const url = config.url || "";
    if (url.indexOf("/web/family/") !== -1) {
      // 家属端请求由 familyHttp 独立处理
      return config;
    }
    if (store.state.apiUrl) {
      config.url = config.url.replace(store.state.apiUrl, "web/");
    }
    const token = store.state.token;
    if (token) config.headers.Authorization = token;
    return config;
  },
  (error) => {
    // eslint-disable-next-line
    return Promise.reject(error);
  }
);

// 配置响应拦截器
axios.interceptors.response.use(
  (res) => {
    const code = res && res.data && Number(res.data.code);
    if (code === 9006) {
      const isFamilyRoute = router.currentRoute.path.indexOf("/family") === 0;
      redirectOnAuthFail(isFamilyRoute, res.data.msg || "登录已过期，请重新登录");
      return Promise.reject(new Error("认证失败"));
    }
    return Promise.resolve(res);
  },
  (error) => {
    const requestUrl = (error.config && error.config.url) || "";
    const isFamilyApi = isFamilyApiUrl(requestUrl);
    const isFamilyRoute = router.currentRoute.path.indexOf("/family") === 0;
    const shouldFamily = isFamilyApi || isFamilyRoute;
    const status = error && error.response && error.response.status;
    const dataCode = error && error.response && error.response.data && Number(error.response.data.code);
    if (status === 401 || status === 403 || dataCode === 9006) {
      const msg = (error.response && error.response.data && error.response.data.msg) || "登录已过期，请重新登录";
      redirectOnAuthFail(shouldFamily, msg);
      return Promise.reject(error);
    }
    if (!isFamilyApi) {
      notification.error({
        message: "请求异常",
        description: (error.response && error.response.data && error.response.data.msg) || error.message,
      });
    }
    return Promise.reject(error);
  }
);

// gotoLogin函数已移除，现在直接使用router.push('/login')

// 根据路由设置标题
router.beforeEach((to, from, next) => {
  NProgress.start();
  if (!to.requireAuth) {
    // 当路由为login时就直接下一步操作
    next();
  } else {
    // 否则就需要判断
    if (store.state.isLogin) {
      // 如果有用户名就进行下一步操作
      next();
    } else {
      next({ path: "/login" }); // 没有用户名就跳转到login页面
      return;
    }
  }
  /*路由发生改变修改页面的title */
  if (to.name) {
    document.title = to.name + "-" + store.state.projectName;
  } else {
    document.title = store.state.projectName;
  }
});

router.afterEach(() => {
  NProgress.done();
});

Date.prototype.format = function (fmt) {
  var o = {
    "M+": this.getMonth() + 1, //月份
    "d+": this.getDate(), //日
    "H+": this.getHours(), //小时
    "m+": this.getMinutes(), //分
    "s+": this.getSeconds(), //秒
    "q+": Math.floor((this.getMonth() + 3) / 3), //季度
    "S": this.getMilliseconds() //毫秒
  };
  if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
  for (var k in o)
    if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : ((
      "00" + o[k]).substr(("" + o[k]).length)));
  return fmt;
}

// 应用启动时检查登录状态
function checkLoginStatus() {
  const isLogin = store.state.isLogin;
  const token = store.state.token;
  
  console.log('应用启动时检查登录状态:', { isLogin, hasToken: !!token });
  
  if (!isLogin || !token) {
    console.log('应用启动时发现未登录或无token，清除状态');
    store.commit('setLoginOut');
    return;
  }
  
  // 检查token是否过期
  try {
    const tokenParts = token.split('.');
    if (tokenParts.length !== 3) {
      console.log('应用启动时发现token格式错误，清除状态');
      store.commit('setLoginOut');
      return;
    }
    
    const payload = JSON.parse(atob(tokenParts[1]));
    const currentTime = Math.floor(Date.now() / 1000);
    
    console.log('应用启动时Token检查:', { 
      exp: payload.exp, 
      currentTime, 
      expired: payload.exp ? payload.exp < currentTime : 'no exp field' 
    });
    
    if (payload.exp && payload.exp < currentTime) {
      console.log('应用启动时发现token已过期，清除状态');
      store.commit('setLoginOut');
    } else {
      console.log('应用启动时登录状态正常');
    }
  } catch (error) {
    console.log('应用启动时token验证失败，清除状态:', error.message);
    store.commit('setLoginOut');
  }
}

// 检查登录状态
checkLoginStatus();

new Vue({
  router,
  store,
  render: (h) => h(App),
  mounted() {
    window.vue = this;
  },
}).$mount("#app");
